import { useToast } from '@chakra-ui/react';
import { useMutation } from '@tanstack/react-query';
import { uploadCommercialHierarchy } from 'services/api/requests/uploads/uploads';

import {
	cleanupBulkCreateLogStorage,
	createBulkCreateErrorLog,
	createBulkCreateSuccessLog,
} from '../../../../utils/logging/bulkCreateLogger';

export const useUploadCommercialHierarchy = (
	setSucessUpload,
	openTableModal,
	isOpen,
	onClose
) => {
	const toast = useToast();

	return useMutation(data => uploadCommercialHierarchy(data), {
		onSuccess: async (success: { quantidade_erros?: number }) => {
			if (
				success.hasOwnProperty('quantidade_erros') &&
				success.quantidade_erros !== undefined &&
				success.quantidade_erros > 0
			) {
				await createBulkCreateErrorLog(
					'/bulkCreate/commercial-hierarchy',
					{
						quantidade_erros: success.quantidade_erros,
						errors: '[]',
					}
				);
				cleanupBulkCreateLogStorage('/bulkCreate/commercial-hierarchy');

				openTableModal();
				setSucessUpload(false);
				if (!isOpen) {
					toast({
						title: 'Arquivo enviado com erros!',
						description:
							'O Arquivo enviado possui erros. Verifique a tabela de erros e corrija-os.',
						position: 'bottom-left',
						status: 'error',
						duration: 8000,
						isClosable: true,
					});
				}
			} else {
				await createBulkCreateSuccessLog(
					'/bulkCreate/commercial-hierarchy'
				);
				cleanupBulkCreateLogStorage('/bulkCreate/commercial-hierarchy');

				setSucessUpload(true);
				onClose();
			}
		},
		onError: async () => {
			await createBulkCreateErrorLog('/bulkCreate/commercial-hierarchy', {
				message: 'Erro desconhecido ao fazer upload do arquivo',
			});
			cleanupBulkCreateLogStorage('/bulkCreate/commercial-hierarchy');

			onClose();
			toast({
				title: 'Erro desconhecido!',
				description: 'Tente enviar novamente.',
				position: 'bottom-left',
				status: 'error',
				duration: 8000,
				isClosable: true,
			});
			setSucessUpload(false);
		},
	});
};
